import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ParcDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-parc',
  templateUrl: './parc.component.html',
  styleUrls: ['./parc.component.css']
})
export class ParcComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;

  private _parcId: number = null;
  Parcs: ParcDto[] = [];


  @Input()
  get parcId() {
    return this._parcId;
  }
  set parcId(val) {
    this._parcId = val;
    this.getParcInComponent();
  }

  @Input() titleNull: string;

  ParcInComponent: string;

  p: Subscription;

  constructor() { }

  ngOnInit() {
    this.p = this.parcs$.subscribe(res => {
      if (res != null) {
        this.Parcs = res;
        this.getParcInComponent();        
      }
    });
  }

  getParcInComponent() {
    let parc = this.Parcs.find(p => p.Id == this.parcId);
    this.ParcInComponent = (parc) ? parc.Identifiant : (this.titleNull) ? this.titleNull : null;
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }
}
